export const WATCH_LIST_ENTRY_MESSAGES = {
  NOT_FOUND: 'No watchlists records were found',
  CREATED: 'The watchlist entry was successfully created',
  UPDATED: 'The watchlist entry was successfully updated',
  DELETED: 'The watchlist entry was successfully deleted',
};


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/constants/watchListEntryMessages.js